export const permissionResponseInterceptor = error => {
    if (error.response?.status === 403 && error.response.data?.error === 'EMAIL_VERIFICATION_REQUIRED') {
        window.dispatchEvent(new CustomEvent('action-permission-required', {detail: error.response.data}))
    }
    return Promise.reject(error)
}
